import { useCallback, useEffect, useRef, useState } from 'react';

/** Copy to the clipboard and flip a label to "Copied" for a moment. */
export function useCopy(resetAfter = 2000) {
  const [copied, setCopied] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => () => (timer.current ? clearTimeout(timer.current) : undefined), []);

  const copy = useCallback(
    async (text: string) => {
      try {
        await navigator.clipboard.writeText(text);
        setCopied(true);
        if (timer.current) clearTimeout(timer.current);
        timer.current = setTimeout(() => setCopied(false), resetAfter);
        return true;
      } catch {
        // Clipboard access can be refused; the value is on screen either way.
        return false;
      }
    },
    [resetAfter],
  );

  return { copied, copy };
}
